import React from 'react'
import { Tooltip } from '@material-ui/core'

function TableCell({ text = '', MaxCharacters = 20 }) {
   if (text?.length > MaxCharacters) {
      const shortText = `${text.slice(0, MaxCharacters).trim()}...`
      return (
         <Tooltip title={text} placement="top" arrow>
            <span>{shortText}</span>
         </Tooltip>
      )
   }
   return <span>{text}</span>
}

export default TableCell
